import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useMediaQuery, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from '@mui/material';
// import Footer from "../menu/footer";
import Navigation from "../menu/navigation";
import Top from "../menu/top";
import { CssBaseline, Box, } from '@mui/material';
import { useSelector } from "react-redux";
import moment from "moment";
import { getUserAttendance, checkIn } from "../../api/attendanceAPI";

const Layout = () => {
  const isMobileOrTablet = useMediaQuery('(max-width:900px)');
  const fetchConfigData = useSelector((state) => state.config.configData);
  const { user } = useSelector((state) => state.tokens);
  
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [attendanceModalOpen, setAttendanceModalOpen] = useState(false);
  const [loadingAttendance, setLoadingAttendance] = useState(false);

  useEffect(() => {
    setDrawerOpen(!isMobileOrTablet);
  }, [isMobileOrTablet]);

  useEffect(() => {
    const checkAttendance = async () => {
      try {
        if(user && user._id) {
          const res = await getUserAttendance(user._id);
          if (res.data && res.data.success) {
            const todayStr = moment().format('YYYY-MM-DD');
            const todayLog = res.data.log.find(l => l.date === todayStr);
            if (!todayLog) {
              setAttendanceModalOpen(true);
            }
          }
        }
      } catch (err) {
        console.error("Attendance check error", err);
      }
    };
    if (user) {
      // Small timeout to not disrupt immediate layout render
      setTimeout(() => {
        checkAttendance();
      }, 1000);
    }
  }, [user]);

  const handleCheckIn = async () => {
    setLoadingAttendance(true);
    try {
      const todayStr = moment().format('YYYY-MM-DD');
      await checkIn({
        user: user._id,
        date: todayStr,
      });
      setAttendanceModalOpen(false);
    } catch(err) {
      console.error(err);
      setAttendanceModalOpen(false);
    } finally {
      setLoadingAttendance(false);
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const getGreeting = () => {
    const hour = moment().hour();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Top toggleDrawer={toggleDrawer} />
      <Navigation drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
          mt: 8,
          transition: 'margin-left 0.3s ease',
          width: drawerOpen ? `calc(100% - ${fetchConfigData?.drawerWidth || 240}px)` : '100%',
          marginLeft: drawerOpen ? '0' : `${-(fetchConfigData?.drawerWidth || 240)}px`,
        }}
      >
        <Outlet />
      </Box>
      {/* <Footer /> */}

      {/* Daily Attendance Check-In Modal */}
      <Dialog open={attendanceModalOpen} onClose={() => { /* optionally force them to check in */ }}>
        <DialogTitle>Mark Your Attendance</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {getGreeting()}, <strong>{user?.fullName}</strong>! You haven't checked in for today ({moment().format('MMMM Do, YYYY')}). 
            <br/><br/>
            Please confirm your attendance to mark yourself as Present.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button 
            onClick={() => setAttendanceModalOpen(false)} 
            color="inherit"
          >
            Later
          </Button>
          <Button 
            onClick={handleCheckIn} 
            variant="contained" 
            color="primary"
            disabled={loadingAttendance}
          >
            {loadingAttendance ? <CircularProgress size={24} /> : "Yes, Check In"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Layout;